import { render, staticRenderFns } from "./VINMVSModal.vue?vue&type=template&id=dfca1236&scoped=true&"
import script from "./VINMVSModal.vue?vue&type=script&lang=js&"
export * from "./VINMVSModal.vue?vue&type=script&lang=js&"
import style0 from "./VINMVSModal.vue?vue&type=style&index=0&id=dfca1236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfca1236",
  null
  
)

export default component.exports